<template>
  <div :class="$style.root">
    <SCAIconButton
      v-bind="{ icon }"
      ref="buttonRef"
      type="toggle"
      appearance="primary"
      size="small"
      @click="handleClick"
    />
  </div>
</template>

<script setup lang="ts">
import { SCAIconButton } from "@scayla/components";
import { computed, useTemplateRef } from "vue";

const props = withDefaults(defineProps<{ isNavHidden?: boolean }>(), {
  isNavHidden: false,
});

const icon = computed(() => (props.isNavHidden ? "phosphor/browser" : "phosphor/layout"));

const buttonRef = useTemplateRef<InstanceType<typeof SCAIconButton>>("buttonRef");

function handleClick() {
  buttonRef.value?.$el?.blur();
}
</script>

<style lang="scss" module>
.root {
  svg {
    fill: var(--color-whiteA-0);
  }
}
</style>
